import { render, staticRenderFns } from "./ListOwnedNumbers.vue?vue&type=template&id=1de1a9d6&scoped=true&"
import script from "./ListOwnedNumbers.vue?vue&type=script&lang=js&"
export * from "./ListOwnedNumbers.vue?vue&type=script&lang=js&"
import style0 from "./ListOwnedNumbers.vue?vue&type=style&index=0&id=1de1a9d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de1a9d6",
  null
  
)

export default component.exports